// Recovered compiled webpack factory 43443. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "AppRouterAnnouncer", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(12115),
    a = r(47650),
    o = "next-route-announcer";
  function i(e) {
    let { tree: t } = e,
      [r, i] = (0, n.useState)(null);
    (0, n.useEffect)(
      () => (
        i(
          (function () {
            var e;
            let t = document.getElementsByName(o)[0];
            if (null == t || null == (e = t.shadowRoot) ? void 0 : e.childNodes[0])
              return t.shadowRoot.childNodes[0];
            {
              let e = document.createElement(o);
              e.style.cssText = "position:absolute";
              let t = document.createElement("div");
              return (
                (t.ariaLive = "assertive"),
                (t.id = "__next-route-announcer__"),
                (t.role = "alert"),
                (t.style.cssText =
                  "position:absolute;border:0;height:1px;margin:-1px;padding:0;width:1px;clip:rect(0 0 0 0);overflow:hidden;white-space:nowrap;word-wrap:normal"),
                e.attachShadow({ mode: "open" }).appendChild(t),
                document.body.appendChild(e),
                t
              );
            }
          })(),
        ),
        () => {
          let e = document.getElementsByTagName(o)[0];
          (null == e ? void 0 : e.isConnected) && document.body.removeChild(e);
        }
      ),
      [],
    );
    let [s, l] = (0, n.useState)(""),
      u = (0, n.useRef)(void 0);
    return (
      (0, n.useEffect)(() => {
        let e = "";
        if (document.title) e = document.title;
        else {
          let t = document.querySelector("h1");
          t && (e = t.innerText || t.textContent || "");
        }
        (void 0 !== u.current && u.current !== e && l(e), (u.current = e));
      }, [t]),
      r ? (0, a.createPortal)(s, r) : null
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
